module.exports = __webpack_public_path__ + "static/img/KOBY-EVANS.eeaa3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KOBY-EVANS.jpg
// module id = a63s
// module chunks = 0